module.exports = __webpack_public_path__ + "static/media/LMT-BNB.a6dc5c6d.svg";